export default __webpack_public_path__ + "static/media/boxKlein.37045d9d.jpg";